import { userFields } from '@openx/components-administration/lib/constants.ts';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField.tsx';
import { useTranslation } from 'react-i18next';

type UserDetailsSectionProps = {
  isEdit?: boolean;
};

export const UserDetailsSection = ({ isEdit }: UserDetailsSectionProps) => {
  const { t } = useTranslation();

  return (
    <FormSection title={t('User Details')} rightColumnSize={5} divider>
      <RHFTextField
        name={userFields.FIRST_NAME}
        label={t('First Name')}
        placeholder={t('Enter First Name')}
        fullWidth
        dataTest="first-name"
      />

      <RHFTextField
        name={userFields.LAST_NAME}
        label={t('Last Name')}
        placeholder={t('Enter Last Name')}
        fullWidth
        dataTest="last-name"
        sx={{ marginTop: 1 }}
      />

      <RHFTextField
        name={userFields.EMAIL}
        label={t('Email')}
        placeholder={t('Enter Email')}
        fullWidth
        dataTest="email"
        sx={{ marginTop: 1 }}
        disabled={isEdit}
      />
    </FormSection>
  );
};
